var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from './live-banner.styles';
import { dictionary } from '@mf-cms/helpers';
let PLiveBanner = class PLiveBanner extends LitElement {
    constructor() {
        super(...arguments);
        this.videos = [];
        this.liveBaseUrl = '';
        this.culture = 'en-GB';
    }
    static { this.styles = styles; }
    async getLiveBannerVideos() {
        try {
            const response = await fetch(`${process.env.API_URL}/portal/livestreams?cache=0&fields=any&access_token=${this.accessToken}`);
            const json = await response.json();
            return json;
        }
        catch (e) {
            console.error(e);
        }
        return [];
    }
    //on created
    async firstUpdated() {
        this.accessToken = window.getAccessToken();
        this.videos = await this.getLiveBannerVideos();
        this.interval = setInterval(async () => {
            this.videos = await this.getLiveBannerVideos();
        }, 10000);
    }
    //on destroy
    disconnectedCallback() {
        clearInterval(this.interval);
        super.disconnectedCallback();
    }
    /**
     * Render component
     * @returns {TemplateResult} Template
     */
    render() {
        return html ` <section class="live-banner ${this.contained ? 'contained' : ''}" aria-label=${dictionary(this.culture, 'liveBanner', 'upcomingBroadcasts')} > ${this.preview ? html `
              <div class="preview">
                <div class="banner upcomming">
                  <div class="banner-inner">
                    <h2>
                      <strong>Live banner:</strong> Upcoming and live broadcasts will be displayed
                      here
                    </h2>
                  </div>
                </div>
              </div>
            `
            : ''}
        ${this.videos.length !== 0 && !this.preview
            ? html ` <ul> ${this.videos.map((video) => html `
                    <li>
                      ${video.status === 'BROADCASTING'
                ? html ` <div class="banner live"> <div class="banner-inner"> <p-video-item culture=${this.culture} islive link=${this.liveBaseUrl + '/' + video.id} video-id=${video.id} summary=${video.description} heading=${video.title} poster=${video.poster} date=${video.liveAt} date-in-heading type="banner" heading-tag="h2" > </p-video-item> </div> </div> `
                : html ` <div class="banner upcomming"> <div class="banner-inner"> <p-badge color="primary" >${new Date(video.liveAt).format('default', { showTime: true, calendarDay: true, culture: this.culture })}</p-badge > <h2>${video.title}</h2> <p-button href=${this.liveBaseUrl + '/' + video.id} color="arrow" >${dictionary(this.culture, 'liveBanner', 'readMore')}</p-button > </div> </div> `}
                    </li>
                  `)}
              </ul>
            `
            : null}
      </section>
    `;
    }
};
__decorate([
    property()
], PLiveBanner.prototype, "accessToken", void 0);
__decorate([
    property()
], PLiveBanner.prototype, "videos", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], PLiveBanner.prototype, "contained", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], PLiveBanner.prototype, "preview", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'live-base-url' })
], PLiveBanner.prototype, "liveBaseUrl", void 0);
__decorate([
    property({ type: String })
], PLiveBanner.prototype, "culture", void 0);
PLiveBanner = __decorate([
    customElement('p-live-banner')
    /**
     * PLiveBanner component
     *
     * @class PLiveBanner
     * @typedef {PLiveBanner}
     * @extends {LitElement}
     */
], PLiveBanner);
export { PLiveBanner };
